import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/checkmark.svg';

export const IconCheckmark: IconComponent = props => <Icon {...props} src={src} />;
